<template>
  <div class="managingPeople hp100 bbox " v-loading="loading">
    <!-- 卡片视图 -->
    <el-card>
      <!-- 搜索-->
        <!-- <el-col>
          <el-button
            plain
            class="add-column-btn bbox"
            @click="gotoDetail('')"
            type="primary"
          >
            <i class="el-icon-plus fw900 f16"></i> 新增</el-button
          >
        </el-col> -->
        <el-col>
          <div class="flex align-center header-search-box">
            <el-button @click="dialogVisible = true" style="background:#F59A23;color:#fff;width:78px">新建</el-button>
          </div>
        </el-col>
      <!-- 用户列表区域 -->
      <div :style="{ height: height + 'px' }" style=" margin-top: 20px;">
        <el-scrollbar style="height: 100%; width: 100%">
          <el-row style="width: 100%">
            <el-table
              :data="tableData"
              border
              fit
              highlight-current-row
              style="width: 100%"
              @sort-change="sortChange"
            >
              <el-table-column label="序号" align="center" type="index">
              </el-table-column>
              <el-table-column label="图片" align="center" prop="图片">
                <template slot-scope="scope">
                  <!-- <span>{{ scope.row.url }}</span> -->
                  <el-image :src="scope.row.url"></el-image>
                </template>
              </el-table-column>
                            <el-table-column label="排序（数值大的优先显示）" align="center" prop="排序">
                <template slot-scope="scope">
                  <span>{{ scope.row.seq }}</span>
                </template>
              </el-table-column>
              <el-table-column label="创建时间" align="center" prop="创建时间">
                <template slot-scope="scope">
                  <span>{{ scope.row.createDt | dataFormat }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="操作"
                align="center"
                class-name="small-padding fixed-width"
              >
              <template slot-scope="scope">
                <span @click="edit(scope.row.id)" style="cursor:pointer;font-weight:500;margin-right:12px;color:#f59a23">编辑</span>
                <span @click="del(scope.row.id)" style="color:#db2f41;font-weight:500;cursor:pointer">删除</span>
              </template>
              </el-table-column>
            </el-table> </el-row
        ></el-scrollbar>
      </div>
      <div class="footerBox">
        <!-- 分页区域 -->
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="queryInfo.currPage"
          :page-sizes="[10, 20, 30, 50]"
          :page-size="queryInfo.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        ></el-pagination>
      </div>
    </el-card>
    <el-dialog
  title="新建轮播图"
  :visible.sync="dialogVisible"
  width="500px"
  >
  <div class="box">
    <div class="top">
      <div class="text">轮播图:</div>
        <el-upload
  class="avatar-uploader"
  :action="$uploadURL"
  :show-file-list="false"
  :on-success="uploadSuccess"
  :before-upload="beforeUpload">
  <img v-if="imageUrl" :src="imageUrl" class="avatar">
  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
    <div slot="tip" class="el-upload__tip">建议上传尺寸大小, (长x宽)  430x300</div>
</el-upload>
    </div>
    <div class="bottom">
      <div class="px">排序（数值大的优先显示）：</div>
      <el-input v-model="diaForm.seq" style="width:120px"></el-input>
    </div>
  </div>
  <span slot="footer" class="dialog-footer">
    <el-button @click="dialogVisible = false">取 消</el-button>
    <el-button style="background:#f59a23;color:#fff" @click="submit">确 定</el-button>
  </span>
</el-dialog>

    <el-dialog
  title="编辑轮播图"
  :visible.sync="dialogVisibleEdit"
  width="500px"
  >
  <div class="box">
    <div class="top">
      <div class="text">轮播图:</div>
        <el-upload
  class="avatar-uploader"
  :action="$uploadURL"
  :show-file-list="false"
  :on-success="uploadSuccessEdit"
  :before-upload="beforeUploadEdit">
  <img v-if="imageUrlEdit" :src="imageUrlEdit" class="avatar">
  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
    <div slot="tip" class="el-upload__tip">建议上传尺寸大小, (长x宽)  800x800</div>
</el-upload>
    </div>
    <div class="bottom">
      <div class="px">排序（数值大的优先显示）：</div>
      <el-input v-model="diaFormEdit.seq" style="width:120px"></el-input>
    </div>
  </div>
  <span slot="footer" class="dialog-footer">
    <el-button @click="dialogVisibleEdit = false">取 消</el-button>
    <el-button style="background:#f59a23;color:#fff" @click="submitEdit">确 定</el-button>
  </span>
</el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      dialogVisible:false,
      dialogVisibleEdit:false,
      imageUrl:'',
      imageUrlEdit:'',
      diaForm:{
        merchantCode:localStorage.getItem('merchantCode'),
        merchantName:localStorage.getItem('merchantName'),
        seq:'',
        url:''
      },
        diaFormEdit:{
        merchantCode:localStorage.getItem('merchantCode'),
        merchantName:localStorage.getItem('merchantName'),
        seq:'',
        url:''
      },
      height: window.innerHeight - 256, //表格高度
      value: "",
      searchInput: "",
      tableData: [],
      loading: true,
      // 获取用户列表查询参数对象
      queryInfo: {
        // 当前页数
        currPage: 1,
        // 每页显示多少数据
        pageSize: 20,
        //查询条件
        condition: {
          id: "",
          merchantCode: localStorage.getItem('merchantCode'),
          merchantName:localStorage.getItem('merchantName')
        }
      },
      userlist: [],
      total: 0,
      // 添加用户对话框
      addDialogVisible: false,
      // 用户添加
      addUserForm: {
        username: "",
        password: "",
        email: "",
        mobile: ""
      },
      // 修改用户
      editDialogVisible: false,
      editUserForm: {},
      // 分配角色对话框
      setRoleDialogVisible: false
    };
  },
  created() {
    this.getListData();
    window.addEventListener("resize", this.getHeight);
  },
  mounted() {
    this.loading = false;
  },
  destroyed() {
    window.removeEventListener("resize", this.getHeight);
  },
  methods: {
    submit(){
      if(this.diaForm.url=='' || this.diaForm.url==null){
        this.$message.error('请先上传图片')
        return
      }
      this.$http.post('/merchantLinePicture/save',this.diaForm).then(res=>{
        this.dialogVisible=false
       if(res.data.code==200){
        this.$message({
          type:'success',
          message:'保存成功'
        })
        this.imageUrl=''
        this.diaForm.seq=''
        this.diaForm.url=''
        this.getListData()
       }else{
        this.$message.error(res.data.message)
       }
      })
    },
        submitEdit(){
      if(this.diaFormEdit.url=='' || this.diaFormEdit.url==null){
        this.$message.error('请先上传图片')
        return
      }
      this.$http.post('/merchantLinePicture/save',this.diaFormEdit).then(res=>{
        this.dialogVisibleEdit=false
       if(res.data.code==200){
        this.$message({
          type:'success',
          message:'修改成功'
        })
        this.imageUrlEdit=''
        this.diaFormEdit.seq=''
        this.diaFormEdit.url=''
        this.getListData()
       }else{
        this.$message.error(res.data.message)
       }
      })
    },
    uploadSuccess(res){
      console.log(res)
      this.imageUrl=res.data.url
      this.diaForm.url=res.data.url
    },
      uploadSuccessEdit(res){
      console.log(res)
      this.imageUrlEdit=res.data.url
      this.diaFormEdit.url=res.data.url
    },
    beforeUpload(file){
      console.log(file)
         const isJPG = file.type.slice(0,5) === 'image' ;
         console.log(file.type.slice(0,5))
        const isLt2M = file.size / 1024 / 1024 < 2;
        if (!isJPG) {
          this.$message.error('请上传图片!');
        }
        if (!isLt2M) {
          this.$message.error('上传图片大小不能超过 2MB!');
        }
        return isJPG && isLt2M;
    },
        beforeUploadEdit(file){
      console.log(file)
         const isJPG = file.type.slice(0,5) === 'image' ;
         console.log(file.type.slice(0,5))
        const isLt2M = file.size / 1024 / 1024 < 2;
        if (!isJPG) {
          this.$message.error('请上传图片!');
        }
        if (!isLt2M) {
          this.$message.error('上传图片大小不能超过 2MB!');
        }
        return isJPG && isLt2M;
    },
    //条件查询
    search() {
      this.getListData();
    },
    // 监听 pagesize改变的事件
    handleSizeChange(newSize) {
      this.queryInfo.pageSize = newSize;
      this.getListData();
    },
    // 监听 页码值 改变事件
    handleCurrentChange(newSize) {
      this.queryInfo.currPage = newSize;
      this.getListData();
    },

    // 监听排序
    sortChange() {},
    edit(id){
      this.dialogVisibleEdit=true
      this.$http.post('/merchantLinePicture/queryOne',{id}).then(res=>{
        console.log(res,'编辑')
        this.imageUrlEdit=res.data.data.url
        this.diaFormEdit=res.data.data
      })
    },

    // 删除用户
    async del(id) {
      const confirmResult = await this.$confirm("确定删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).catch(err => err);
      if (confirmResult === "confirm") {
        var that = this;
        that.$http
          .post("/merchantLinePicture/delete", { id: id })
          .then(function(response) {
            that.$notify.success({
              title: "提示",
              message: "删除成功",
              showClose: true
            });
            that.getListData();
          });
      }
    },
    getListData() {
      // 获取列表
      var that = this;
      that.$http
        .post("/merchantLinePicture/list", that.queryInfo)
        .then(function(response) {
          console.log(response.data.data);
          if (response.data.code == 200) {
            that.total = response.data.data.count;
            that.queryInfo.currPage = response.data.data.currPage;
            that.tableData = response.data.data.data;
          }
        });
    },
    // 监听表格高度
    getHeight() {
      this.height = window.innerHeight - 256;
    }
  }
};
</script>

<style lang="less" scoped>
.textblue {
  color: #008eff;
}
.managingPeople {
  .el-card {
    height: calc(100vh - 114px);
    position: relative;
    .el-select > .el-input {
      width: 200px;
    }
    .header-search-box .header-search-input {
      width: 325px;
    }
    input::placeholder {
      font-size: 12px;
    }
    .handle-btn .el-button.add-column-btn {
      width: 100%;
      font-size: 13px;
      background-color: transparent;
      color: #008eff;
      z-index: 102;
    }
    .footerBox {
      position: absolute;
      width: 100%;
      height: 78px;
      left: 20px;
      right: 20px;
      bottom: 0;
    }
  }
}
/deep/.el-scrollbar__view {
  min-width: 100%;
}
/deep/.el-scrollbar__wrap {
  overflow-x: auto;
  height: calc(100%); //多出来的20px是横向滚动条默认的样式
  width: 100%;
}
/deep/.el-scrollbar .el-scrollbar__wrap .el-scrollbar__view {
  white-space: nowrap;
  display: inline-block;
}
/deep/ .box{
  .top{
    display: flex;
    margin-left: 127px;
    align-items: center;
    .text{
      margin-right: 12px;
    }
  }
  .bottom{
    margin-top: 26px;
    display: flex;
    align-items: center;
  }
}
 /deep/ .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9 !important;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;

  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 78px;
    height: 78px;
    line-height: 78px;
    text-align: center;
  }
  .avatar {
    width: 78px;
    height: 78px;
    display: block;
  }
</style>
